import styled from 'styled-components';

import { gridSizes } from 'utils/style';

import RecurringOrderSuggestionsModal from 'components/RecurringOrderSuggestionsModal/container';

export default styled(RecurringOrderSuggestionsModal)`
  & {
    padding: ${gridSizes('L')};
    padding-bottom: ${gridSizes('S')};
    display: flex;
    flex-direction: column;
  }
`;
